import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  constructor(public router: Router, public service: GlobalService) {
    // this.service.sideIcon();
  }

  over(status = 1) {
    if (localStorage.getItem('sidebar_selection')) {
      const sidebar_selection = localStorage.getItem('sidebar_selection');
      if (sidebar_selection && status == 1) {
        $('.main-site-wrap').addClass('sidebar-hovered');
      } else {
        $('.main-site-wrap').removeClass('sidebar-hovered');
      }
    }
  }



}
